import React, {
    ReactElement,
} from "react";

import { RiMailLine } from "@remixicon/react";
import {
    ChatSettingsChannelEmail,
} from "../../../../../__generated__/api";
import Editor from "../../../../../components/agent-v3/editor/Editor";
import { ProxyProperty } from "../../../../../components/dirty-tracker/FormTracker";
import SettingsContainer from "../../../../../components/theme/settings";
import Toggle from "../../../../../components/theme/toggle/Toggle";
import { useSetTitle } from "../../base";
import Styles from "../Chat.module.scss";

export interface Props {
    data: ProxyProperty<ChatSettingsChannelEmail>
}

export default function EmailSettings({ data }: Props): ReactElement {
    const properties = data.useBuilder(
        builder => builder
            .property("shouldSendFeedback", current => current?.shouldSendFeedback ?? false)
            .property("feedbackIntroduction", current => current?.feedbackIntroduction),
    );

    useSetTitle(data?.cleanValue.name ? (
        <>
            <RiMailLine className={Styles["nav-icon"]} />
            {" "}
            {data?.cleanValue.name}
        </>
    ) : undefined, [data]);

    return (

        <SettingsContainer.Section
            title="Email Settings"
        >
            <SettingsContainer.Setting
                title="Send Feedback"
                description="This message will automatically be added to the bottom of each email"
                permissions={SettingsContainer.Setting.Permissions.GroupAdministrator}
            >
                <Toggle
                    checked={properties.shouldSendFeedback.value}
                    onChange={properties.shouldSendFeedback.setCheckedFromInput}
                />
            </SettingsContainer.Setting>

            <SettingsContainer.Setting
                title="Feedback Message"
                description="This message will appear at the top of the feedback email."
                permissions={SettingsContainer.Setting.Permissions.GroupAdministrator}
            >

                <Editor
                    value={properties.feedbackIntroduction.value ?? ""}
                    onChange={properties.feedbackIntroduction.setValue}
                    size="medium"
                    hasBorder
                    placeholder="The conversation has ended, please tell us how we did."
                />
            </SettingsContainer.Setting>

        </SettingsContainer.Section>

    );
}

EmailSettings.defaultProps = {
};
